import { ProductImage } from './ProductImage';
import { categoryImageKey } from './product-image-sync';

export function CategoryImage({ prefix, imageUrl, alt = '分类图片' }: {
  prefix: string;
  imageUrl?: string | null | undefined;
  alt?: string;
}) {
  return <ProductImage productId={categoryImageKey(prefix)} imageUrl={imageUrl} alt={alt} />;
}
